import React, { useState } from 'react';
import { db } from '../AppointmentComp/firebase';
import { collection, addDoc } from 'firebase/firestore';
import emailjs from 'emailjs-com'; // Import EmailJS
import "./homeservice.css";

function HomeService() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    address: '',
    date: '',
    additionalInfo: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Save to Firestore
      const docRef = await addDoc(collection(db, 'opticalHomeservice'), formData);
      console.log('Document written with ID:', docRef.id);

      // Send email using EmailJS
      const emailData = {
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        date: formData.date,
        additionalInfo: formData.additionalInfo,
      };

      // Replace 'YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', 'YOUR_USER_ID' with your EmailJS service details
      const emailResponse = await emailjs.send(
        'service_g4q1q4f',  
        'template_65fd1d1', 
        emailData,         
        'zM40ykd4Fa6c4SUtE'     
      );
      console.log('Request sent successfully:', emailResponse);

      // Reset form and show success message
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        address: '',
        date: '',
        additionalInfo: '',
      });
      setSubmissionStatus('success');
    } catch (error) {
      console.error('Error adding document:', error);
      setSubmissionStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Banner Image */}
      <div className="home-service-banner-container">
        <img src="/homeservice.png" alt="homeservice Banner" className="home-service-banner-image" />
      </div>

      <div className="home-service-form-container">
        <h1 className="home-service-header">Request Home Service for Eye Care</h1>
        <p className="home-service-description">
          Fill out the form below to request a home visit from our eye care professionals. We will review your request and contact you via email.
        </p>
        <form className="home-service-form" onSubmit={handleSubmit}>
        {/* Row 1: Full Name and Email */}
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="fullName">Full Name:</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Row 2: Phone and Address */}
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="phone">Phone Number:</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              maxLength="10"
              pattern="\d{10}"
              title="Please enter a 10-digit phone number"
            />
          </div>
          <div className="form-group">
            <label htmlFor="address">Address:</label>
            <textarea
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>
        </div>

          {/* Row 3: Preferred Date and Additional Information */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="date">Preferred Date for Service:</label>
              <input
                type="date"
                id="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                min={new Date().toISOString().split("T")[0]}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="additionalInfo">Additional Information:</label>
              <textarea
                id="additionalInfo"
                name="additionalInfo"
                value={formData.additionalInfo}
                onChange={handleChange}
              />
            </div>
          </div>

            <button
              type="submit"
              className="home-service-submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>

          {submissionStatus === 'success' && (
            <p className="submission-status success-status">
              Your request has been submitted successfully! We will contact you shortly via email.
            </p>
          )}
          {submissionStatus === 'error' && (
            <p className="submission-status error-status">
              There was an error submitting your request. Please try again later.
            </p>
          )}
   </div>

    </>
  );
}

export default HomeService;
